import React from 'react';

import { Box, Icon, Flex, Link, Text } from 'core/components';
import styled from 'styled-components';
import { ResultMenuItemSingleRow } from './ResultMenuItem';

const KnowledgeBaseLink = styled(Link)`
  border-radius: 40px;
  border: 1px solid #fff;
  align-self: start;
  background-color: ${({ bgColor }) => bgColor};
`;

function PortalPage({ item, selected, query, IconCmp, onItemClick, ...rest }) {
  const { id, kb_entry, path, nav_menu_name } = item || {};

  const kbPillBgColor = selected ? '#fff' : '#0180ED';
  const kbPillColor = selected ? 'primary' : '#fff';

  return (
    <ResultMenuItemSingleRow
      selected={selected}
      onClick={() => onItemClick({ type: 'navigation', id, path: `/v4/${path}` }, 'Search Results')}
      {...rest}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <IconCmp iconSize={22} />
      </Flex>

      <Box gridArea="title">
        <Text fontSize="14px" className="title">
          {nav_menu_name}
        </Text>
      </Box>
      <Flex alignItems="center" gridArea="rightContent" alignSelf="start">
        {!!kb_entry && (
          <KnowledgeBaseLink
            blank
            color={kbPillColor}
            bgColor={kbPillBgColor}
            to={kb_entry}
            fontSize={12}
            py="4px"
            px="8px"
          >
            <Icon iconSize={12} icon="help" mr="4px" pb="1px" color={kbPillColor} />
            KB
          </KnowledgeBaseLink>
        )}
        <Icon icon="key-enter" color="#fff" ml={1} opacity={selected ? 1 : 0} />
      </Flex>
    </ResultMenuItemSingleRow>
  );
}

export default PortalPage;
